import { render, staticRenderFns } from "./WebsocketData.vue?vue&type=template&id=2d03e561&scoped=true"
import script from "./WebsocketData.vue?vue&type=script&lang=js"
export * from "./WebsocketData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d03e561",
  null
  
)

export default component.exports